module.exports = __webpack_public_path__ + "img/op_img-header.d8697bd.png";